var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 7.875L7.90917 7.85833C8.01602 7.80495 8.13594 7.7833 8.25472 7.79596C8.3735 7.80862 8.48616 7.85505 8.57937 7.92976C8.67258 8.00446 8.74242 8.10432 8.78064 8.21749C8.81885 8.33066 8.82384 8.45242 8.795 8.56833L8.205 10.9317C8.17595 11.0476 8.18078 11.1695 8.21891 11.2828C8.25704 11.3961 8.32687 11.4961 8.42011 11.571C8.51336 11.6458 8.62611 11.6923 8.745 11.705C8.86388 11.7177 8.9839 11.696 9.09083 11.6425L9.125 11.625M16 8.5C16 9.48491 15.806 10.4602 15.4291 11.3701C15.0522 12.2801 14.4997 13.1069 13.8033 13.8033C13.1069 14.4997 12.2801 15.0522 11.3701 15.4291C10.4602 15.806 9.48491 16 8.5 16C7.51509 16 6.53982 15.806 5.62987 15.4291C4.71993 15.0522 3.89314 14.4997 3.1967 13.8033C2.50026 13.1069 1.94781 12.2801 1.5709 11.3701C1.19399 10.4602 1 9.48491 1 8.5C1 6.51088 1.79018 4.60322 3.1967 3.1967C4.60322 1.79018 6.51088 1 8.5 1C10.4891 1 12.3968 1.79018 13.8033 3.1967C15.2098 4.60322 16 6.51088 16 8.5ZM8.5 5.375H8.50667V5.38167H8.5V5.375Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCaution);
export default __webpack_public_path__ + "static/media/roundCaution.cafd199cbaadf19dd514240482ece728.svg";
export { ForwardRef as ReactComponent };